import { BaseDTO } from '../global/base.dto';

export class CalendarEventCategoryDTO extends BaseDTO {

    name: string;

    description: string;

    backgroundColor: string;

    borderColor: string;

    textColor: string;

}
